export default "__VITE_ASSET__DR5ydc2O__"